import haunted from "haunted/lib/core";
import { render } from "lit-html";

const H = haunted({ render });

export const component = H.component;
